import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

/**
 * 可搜索下拉在未展开时 input 为 readonly。
 * 手机在这次点击里不会弹出键盘，等下拉打开后再取消 readonly 已经来不及。
 * 窄屏上让单选可搜索框始终可输入；多选则把焦点交给真正的搜索框。
 */
function isNarrowScreen() {
  return typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(max-width: 1024px), (pointer: coarse)').matches
}

function patchFilterableSelectKeyboard() {
  const Select = ElementUI.Select
  if (!Select || !Select.computed || typeof Select.computed.readonly !== 'function') {
    return
  }
  const originalReadonly = Select.computed.readonly
  Select.computed.readonly = function () {
    if (isNarrowScreen() && this.filterable && !this.multiple) {
      return false
    }
    return originalReadonly.call(this)
  }
  if (Select.methods && typeof Select.methods.handleFocus === 'function') {
    const originalHandleFocus = Select.methods.handleFocus
    Select.methods.handleFocus = function (event) {
      originalHandleFocus.call(this, event)
      if (!isNarrowScreen() || !this.multiple || !this.filterable || !this.$refs.input) {
        return
      }
      if (event && event.target === this.$refs.input) {
        return
      }
      this.$refs.input.focus()
    }
  }
}

patchFilterableSelectKeyboard()

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import { installBlockSwipeNavigation } from '@/utils/blockSwipeNavigation'

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

installBlockSwipeNavigation()

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js